<template>
  <div class="preloader">
    <div class="spinner-blink" :style="`background: url(${logo}) no-repeat center / contain;`" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

defineOptions({
  name: "preloader",
});

const { locale } = useI18n();
const logo = computed(() => (locale.value === "de" ? require(`@/assets/images/logo-de.svg`) : require(`@/assets/images/logo-en.svg`)));
</script>
